module.exports = __webpack_public_path__ + "static/media/404.6cd1ecf7.webp";